import * as React from 'react';

const NotFound: React.FC<{}> = () => {
    return <>
        <div style={{ textAlign: 'center', width: '80%', transform: ' translate(-50%, -50%)', position: 'absolute', top: '30%', left: '50%' }}>
            <img src="https://res-zalo.zadn.vn/upload/media/2023/9/29/warning_icon_1695981354095_398874.png" alt="" style={{ width: '75px', height: '75px', margin: 'auto' }} />
            <p style={{ fontSize: '15px', lineHeight: '24px', color: '#333' }}>This page doesn’t exist. Sorry for the
                inconvenience.<br />Trang này không tìm thấy hoặc không hợp lệ. Xin lỗi vì sự bất tiện này.</p>
        </div>
    </>
};

export default NotFound;
